import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "emp-settings-page" }
const _hoisted_2 = { class: "app-header" }
const _hoisted_3 = { class: "page-content" }
const _hoisted_4 = { class: "settings-card" }
const _hoisted_5 = { class: "item-left" }
const _hoisted_6 = { class: "item-left" }
const _hoisted_7 = { class: "item-left" }
const _hoisted_8 = { class: "dialog-header" }
const _hoisted_9 = { class: "dialog-content" }
const _hoisted_10 = { class: "input-group" }
const _hoisted_11 = { class: "password-input" }
const _hoisted_12 = ["type"]
const _hoisted_13 = { class: "input-group" }
const _hoisted_14 = { class: "password-input" }
const _hoisted_15 = ["type"]
const _hoisted_16 = {
  key: 0,
  class: "input-hint"
}
const _hoisted_17 = { class: "input-group" }
const _hoisted_18 = { class: "password-input" }
const _hoisted_19 = ["type"]
const _hoisted_20 = {
  key: 0,
  class: "input-hint error"
}
const _hoisted_21 = {
  key: 1,
  class: "input-hint success"
}
const _hoisted_22 = { class: "dialog-actions" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { key: 1 }

import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import axios from 'axios';


export default /*@__PURE__*/_defineComponent({
  __name: 'EmpSettings',
  setup(__props) {

const store = useStore();
const router = useRouter();

// 뒤로가기
const goBack = () => {
  router.back();
};

// 사원 정보
const pwaUser = computed(() => store.getters['pwa/pwaUser']);

// 비밀번호 변경 상태
const showPasswordDialog = ref(false);
const showCurrentPw = ref(false);
const showNewPw = ref(false);
const showConfirmPw = ref(false);
const isChangingPassword = ref(false);
const passwordForm = ref({
  currentPw: '',
  newPw: '',
  confirmPw: ''
});

// 로그아웃 다이얼로그
const showLogoutDialog = ref(false);

// 폼 유효성 검사
const isPasswordFormValid = computed(() => {
  return (
    passwordForm.value.currentPw.length > 0 &&
    passwordForm.value.newPw.length >= 4 &&
    passwordForm.value.newPw === passwordForm.value.confirmPw
  );
});

// 비밀번호 다이얼로그 열기
const openPasswordDialog = () => {
  passwordForm.value = { currentPw: '', newPw: '', confirmPw: '' };
  showCurrentPw.value = false;
  showNewPw.value = false;
  showConfirmPw.value = false;
  showPasswordDialog.value = true;
};

// 비밀번호 다이얼로그 닫기
const closePasswordDialog = () => {
  showPasswordDialog.value = false;
  passwordForm.value = { currentPw: '', newPw: '', confirmPw: '' };
};

// 비밀번호 변경
const changePassword = async () => {
  if (!isPasswordFormValid.value) return;
  if (!pwaUser.value?.emp_idx) {
    store.commit('showSnackbar', {
      text: '사원 정보를 찾을 수 없습니다.',
      color: 'error'
    });
    return;
  }

  isChangingPassword.value = true;
  try {
    const response = await axios.put(
      `/api/emp/facility/${pwaUser.value.emp_idx}/password`,
      {
        currentPw: passwordForm.value.currentPw,
        newPw: passwordForm.value.newPw
      },
      { withCredentials: true }
    );

    if (response.data.success) {
      store.commit('showSnackbar', {
        text: '비밀번호가 성공적으로 변경되었습니다.',
        color: 'success'
      });
      closePasswordDialog();
    } else {
      store.commit('showSnackbar', {
        text: response.data.message || '비밀번호 변경에 실패했습니다.',
        color: 'error'
      });
    }
  } catch (error: any) {
    console.error('비밀번호 변경 오류:', error);
    store.commit('showSnackbar', {
      text: error.response?.data?.message || '비밀번호 변경 중 오류가 발생했습니다.',
      color: 'error'
    });
  } finally {
    isChangingPassword.value = false;
  }
};

const handleNotification = () => {
  store.commit('showSnackbar', {
    text: '알림 설정 기능이 곧 제공됩니다.',
    color: 'info'
  });
};

const handleLogout = () => {
  showLogoutDialog.value = true;
};

const confirmLogout = async () => {
  showLogoutDialog.value = false;
  await store.dispatch('pwa/performPwaLogout');
  router.push('/pwa/login');
};

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "back-btn",
        onClick: goBack
      }, [
        _createVNode(_component_v_icon, {
          size: "24",
          color: "white"
        }, {
          default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
            _createTextVNode("mdi-arrow-left", -1)
          ]))]),
          _: 1
        })
      ]),
      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "header-title" }, "설정", -1)),
      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "header-spacer" }, null, -1))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: "settings-item",
          onClick: openPasswordDialog
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_v_icon, {
              color: "#059669",
              size: "24"
            }, {
              default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                _createTextVNode("mdi-lock-reset", -1)
              ]))]),
              _: 1
            }),
            _cache[13] || (_cache[13] = _createElementVNode("span", null, "비밀번호 변경", -1))
          ]),
          _createVNode(_component_v_icon, {
            color: "#9ca3af",
            size: "20"
          }, {
            default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
              _createTextVNode("mdi-chevron-right", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("div", {
          class: "settings-item",
          onClick: handleNotification
        }, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_v_icon, {
              color: "#059669",
              size: "24"
            }, {
              default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                _createTextVNode("mdi-bell-outline", -1)
              ]))]),
              _: 1
            }),
            _cache[16] || (_cache[16] = _createElementVNode("span", null, "알림 설정", -1))
          ]),
          _createVNode(_component_v_icon, {
            color: "#9ca3af",
            size: "20"
          }, {
            default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
              _createTextVNode("mdi-chevron-right", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("div", {
          class: "settings-item logout",
          onClick: handleLogout
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_v_icon, {
              color: "#dc2626",
              size: "24"
            }, {
              default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                _createTextVNode("mdi-logout", -1)
              ]))]),
              _: 1
            }),
            _cache[19] || (_cache[19] = _createElementVNode("span", null, "로그아웃", -1))
          ])
        ])
      ]),
      _cache[20] || (_cache[20] = _createElementVNode("div", { class: "version-info" }, [
        _createElementVNode("span", null, "버전 1.0.0")
      ], -1))
    ]),
    _createVNode(_component_v_dialog, {
      modelValue: showPasswordDialog.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((showPasswordDialog).value = $event)),
      "max-width": "360"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "password-dialog-card" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _cache[22] || (_cache[22] = _createElementVNode("h2", null, "비밀번호 변경", -1)),
              _createElementVNode("button", {
                class: "close-btn",
                onClick: closePasswordDialog
              }, [
                _createVNode(_component_v_icon, { size: "20" }, {
                  default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                    _createTextVNode("mdi-close", -1)
                  ]))]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _cache[23] || (_cache[23] = _createElementVNode("label", null, "현재 비밀번호", -1)),
                _createElementVNode("div", _hoisted_11, [
                  _withDirectives(_createElementVNode("input", {
                    type: showCurrentPw.value ? 'text' : 'password',
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((passwordForm.value.currentPw) = $event)),
                    placeholder: "현재 비밀번호 입력"
                  }, null, 8, _hoisted_12), [
                    [_vModelDynamic, passwordForm.value.currentPw]
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "toggle-btn",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (showCurrentPw.value = !showCurrentPw.value))
                  }, [
                    _createVNode(_component_v_icon, {
                      size: "20",
                      color: "#9ca3af"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(showCurrentPw.value ? 'mdi-eye-off' : 'mdi-eye'), 1)
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _cache[24] || (_cache[24] = _createElementVNode("label", null, "새 비밀번호", -1)),
                _createElementVNode("div", _hoisted_14, [
                  _withDirectives(_createElementVNode("input", {
                    type: showNewPw.value ? 'text' : 'password',
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((passwordForm.value.newPw) = $event)),
                    placeholder: "새 비밀번호 입력 (4자 이상)"
                  }, null, 8, _hoisted_15), [
                    [_vModelDynamic, passwordForm.value.newPw]
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "toggle-btn",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (showNewPw.value = !showNewPw.value))
                  }, [
                    _createVNode(_component_v_icon, {
                      size: "20",
                      color: "#9ca3af"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(showNewPw.value ? 'mdi-eye-off' : 'mdi-eye'), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                (passwordForm.value.newPw && passwordForm.value.newPw.length < 4)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_16, " 비밀번호는 4자 이상이어야 합니다. "))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _cache[25] || (_cache[25] = _createElementVNode("label", null, "새 비밀번호 확인", -1)),
                _createElementVNode("div", _hoisted_18, [
                  _withDirectives(_createElementVNode("input", {
                    type: showConfirmPw.value ? 'text' : 'password',
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((passwordForm.value.confirmPw) = $event)),
                    placeholder: "새 비밀번호 다시 입력"
                  }, null, 8, _hoisted_19), [
                    [_vModelDynamic, passwordForm.value.confirmPw]
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "toggle-btn",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (showConfirmPw.value = !showConfirmPw.value))
                  }, [
                    _createVNode(_component_v_icon, {
                      size: "20",
                      color: "#9ca3af"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(showConfirmPw.value ? 'mdi-eye-off' : 'mdi-eye'), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                (passwordForm.value.confirmPw && passwordForm.value.newPw !== passwordForm.value.confirmPw)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_20, " 비밀번호가 일치하지 않습니다. "))
                  : (passwordForm.value.confirmPw && passwordForm.value.newPw === passwordForm.value.confirmPw)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_21, " 비밀번호가 일치합니다. "))
                    : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("button", {
                class: "cancel-btn",
                onClick: closePasswordDialog
              }, "취소"),
              _createElementVNode("button", {
                class: "submit-btn",
                disabled: !isPasswordFormValid.value || isChangingPassword.value,
                onClick: changePassword
              }, [
                (isChangingPassword.value)
                  ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                      key: 0,
                      indeterminate: "",
                      size: "18",
                      width: "2",
                      color: "white"
                    }))
                  : (_openBlock(), _createElementBlock("span", _hoisted_24, "변경하기"))
              ], 8, _hoisted_23)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: showLogoutDialog.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((showLogoutDialog).value = $event)),
      "max-width": "300"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "logout-dialog-card" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "dialog-title" }, {
              default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                _createTextVNode("로그아웃", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_card_text, { class: "dialog-text" }, {
              default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                _createTextVNode(" 정말 로그아웃 하시겠습니까? ", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, { class: "dialog-btns" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  variant: "text",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (showLogoutDialog.value = false))
                }, {
                  default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                    _createTextVNode("취소", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  color: "error",
                  variant: "flat",
                  onClick: confirmLogout
                }, {
                  default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                    _createTextVNode("로그아웃", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})